import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/pfc";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();

  useEffect(() => {
    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login"); return; }
    const session_id = m[1];

    api.post("/auth/google/session", { session_id })
      .then(async () => {
        await refresh();
        window.history.replaceState(null, "", "/dashboard");
        nav("/dashboard");
      })
      .catch(() => {
        nav("/login?error=oauth");
      });
  }, [nav, refresh]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-callback">
      <div className="label text-pfc-gold animate-pulse">Authenticating…</div>
    </div>
  );
}
